import { useEffect, useRef, useState } from "react";

type TUseNearViewportOptions = {
	rootMargin?: string;
	threshold?: number;
};

export const useNearViewport = ({
	rootMargin = "600px 0px",
	threshold = 0.01,
}: TUseNearViewportOptions = {}) => {
	const containerRef = useRef<HTMLDivElement | null>(null);
	const [isNearViewport, setIsNearViewport] =
		useState(false);

	useEffect(() => {
		if (isNearViewport) {
			return;
		}

		const node = containerRef.current;
		if (!node) {
			return;
		}

		if (typeof IntersectionObserver === "undefined") {
			setIsNearViewport(true);
			return;
		}

		const observer = new IntersectionObserver(
			(entries) => {
				const [entry] = entries;

				if (
					entry.isIntersecting ||
					entry.intersectionRatio > 0
				) {
					setIsNearViewport(true);
					observer.disconnect();
				}
			},
			{
				rootMargin,
				threshold,
			}
		);

		observer.observe(node);

		return () => {
			observer.disconnect();
		};
	}, [isNearViewport, rootMargin, threshold]);

	return {
		containerRef,
		isNearViewport,
	};
};
